export default {"src":"/_next/static/media/gavel_40.82302bd1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};